import { useURL } from '@kalyzee/kast-web-sdk/web-components';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { SessionMode } from '../../contexts/appStore/hooks';
import { NavigateGlobalQuery, getGlobalQuery, getGlobalQueryLabel } from '../../helpers/navigate';
import { AppLoadingView } from '../utils/AppLoadingView';
import { LoadingView } from '../utils/LoadingView';
import { PAGE_PATHS } from './PageContext';

interface PublicRedirectionRouteProps {
  mode: SessionMode;
}

const PublicRedirectionRoute = ({ mode }: PublicRedirectionRouteProps) => {
  const url = useURL();
  const navigate = useNavigate();

  useEffect(() => {
    const newUrl = new URL(url);
    const currentPath = url.pathname.startsWith('/') ? url.pathname.replace('/', '') : url.pathname;
    newUrl.pathname = PAGE_PATHS[SessionMode.MASTER].login;
    if (currentPath.length && currentPath !== 'logout' && currentPath !== 'login') {
      const redirect = `${currentPath}${encodeURIComponent(url.search)}`;
      newUrl.searchParams.set('redirect', redirect);
    }
    if (getGlobalQuery(url.href, NavigateGlobalQuery.SLAVE)) {
      newUrl.searchParams.set(getGlobalQueryLabel(NavigateGlobalQuery.SLAVE), "true");
    }
    const navigateTo = newUrl.pathname + newUrl.search;
    navigate(navigateTo, { replace: true });
  }, [url, navigate]);

  // Until navigate() commits the redirect (next render), this route element
  // is what's on screen. Render the same chrome (topbar + AnimatedBackground
  // via AppLoadingView) so logout → login doesn't flash an empty page.
  // Slave mode skips MasterUI since it doesn't use the master chrome.
  if (mode === SessionMode.MASTER) return <AppLoadingView />;
  return <LoadingView fullscreen />;
};

export default PublicRedirectionRoute;
